'use client'

import { useEffect } from 'react'
import { getVersionInfo } from '@/utils/env'

/**
 * Logs app version and build info to console on startup.
 * Runs in all environments including production for debugging support.
 * Renders nothing - zero DOM impact.
 */
export function VersionLogger() {
  useEffect(() => {
    const { version, buildId } = getVersionInfo()

    console.log(
      '%cDDay App Info\n%cVersion: %s\n%cBuild: %s',
      'color: #ef4444; font-weight: bold; font-size: 14px;',
      'color: #ef4444;',
      version,
      'color: #ef4444;',
      buildId
    )
  }, [])

  return null
}
